import React, { useState, useEffect } from 'react';
import { usePublicClient } from 'wagmi';
import { formatUnits } from 'viem';
import { Wallet } from 'lucide-react';

const TREASURY_ADDRESS = '0xcAD86262Df9fe4333cD923f7321757E910A0447F';

export const TreasuryBalance = () => {
  const [balance, setBalance] = useState('0');
  const [loading, setLoading] = useState(true);
  const publicClient = usePublicClient();

  useEffect(() => {
    fetchBalance();
    const interval = setInterval(fetchBalance, 30000);
    return () => clearInterval(interval);
  }, [publicClient]);

  const fetchBalance = async () => {
    try {
      if (!publicClient) return;
      
      // Fetch native BNB balance (not ERC20)
      const balanceResult = await publicClient.getBalance({
        address: TREASURY_ADDRESS,
      });

      const formattedBalance = formatUnits(balanceResult, 18);
      setBalance(formattedBalance);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching treasury BNB balance:', error);
      setLoading(false);
    }
  };

  const formatNumber = (num) => {
    const value = parseFloat(num);
    // Show more decimals for small amounts
    if (value > 0 && value < 1) {
      return value.toLocaleString('en-US', {
        minimumFractionDigits: 4,
        maximumFractionDigits: 4,
      });
    }
    return value.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  if (loading) {
    return (
      <div className="inline-flex items-center gap-3 bg-[#f0b90b]/10 border border-[#f0b90b]/20 rounded-full px-5 py-2.5">
        <div className="animate-pulse flex items-center gap-2">
          <div className="w-4 h-4 bg-[#f0b90b]/30 rounded-full"></div>
          <div className="h-4 w-24 bg-[#f0b90b]/30 rounded"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="inline-flex items-center gap-3 bg-[#f0b90b]/10 border border-[#f0b90b]/20 rounded-full px-5 py-2.5">
      <div className="w-8 h-8 bg-[#f0b90b] rounded-full flex items-center justify-center">
        <Wallet className="w-4 h-4 text-white" />
      </div>
      <div className="flex items-center gap-2">
        <span className="text-sm text-[#666]">Treasury:</span>
        <span className="font-bold text-[#333]">{formatNumber(balance)} BNB</span>
      </div>
      <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" title="Live"></div>
    </div>
  );
};
